import { render, staticRenderFns } from "./ArticleDetails.vue?vue&type=template&id=0984a7d8"
import script from "./ArticleDetails.vue?vue&type=script&lang=js"
export * from "./ArticleDetails.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetails.vue?vue&type=style&index=0&id=0984a7d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports